<template>

  <transition name="fade">
    <div class="modal-wrapper" v-if="this.isshow" :class="{ open: this.isshow }" @click="onClose">

      <div class="modal-container">

        <div class="modal-content">

          <div class="modal" @click.stop>

            <button type="button" class="modal-btn-close" @click="onClose">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="#41444C" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 16.8233L13.0708 9.9825L19.9042 3.08083L16.8233 0L9.98 6.93167L3.055 0.0958333L0 3.15083L6.93417 10.0175L0.0958333 16.945L3.15083 20L10.015 13.0683L16.9192 19.9042L20 16.8233Z" fill="inherit"/>
              </svg>
            </button>

            <slot name="content">

            </slot>

          </div>

        </div>

      </div>

    </div>
  </transition>

</template>

<script>
import src from "../controllers/components/ModalCtrl";
export default src;
</script>